import { useNavigate } from "react-router-dom";
import { toggleMenu } from "../../../common/custom";
import { useEffect, useState } from "react";
import { getMenus, getProviderPortalRole } from "../../../Utils/types";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess } from "../../../Utils/helper";
import Modal from "react-modal";
import { callHomePageAPI } from "./commonfunctionality";
import { clearCurrentPage } from "../../NetworkPortal/ProviderProfileDetails/helper";

const LeftSideBar = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isLogoutPopup, setIsLogoutPopup] = useState(false);

  useEffect(() => {
    callHomePageAPI(dispatch);
  }, [getProviderPortalRole()]);

  const providerDetails = useSelector(
    (state) => state.homeReducer.getHomePageDetails?.providerDetail?.[0]
  );

  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);

  return (
    <>
      <div className="sidebar-menu" id="sidebar-menu">
        <div className="sidebar-logo">
          <img
            src={
              providerDetails?.icon
                ? providerDetails?.icon
                : "./images/noimageavailable.jpg"
            }
            className="img-fluid"
            alt=""
          />
        </div>
        <div className="sidebar-header">
          <h3 className="name">{providerDetails?.providerName}</h3>
          {/* <p className="services">Pathalogy Services</p> */}
        </div>
        <ul>
          {getMenus()?.map((ele, index) => {
            return (
              <li
                key={index}
                style={{
                  backgroundColor:
                    window.location.pathname.includes(ele?.menuItem?.url) &&
                    "#5252A3",
                  color:
                    window.location.pathname.includes(ele?.menuItem?.url) &&
                    "white",
                }}
                onClick={() => {
                  clearCurrentPage(dispatch);
                  if (isPageEdit) {
                    getSnackbarSuccess(
                      "warning",
                      "Please save the details",
                      dispatch
                    );
                  } else {
                    window.innerWidth < 900 && toggleMenu();
                    navigate(ele?.menuItem?.url);
                  }
                }}
              >
                <span className="icon">
                  <img
                    style={{
                      filter:
                        window.location.pathname.includes(ele?.menuItem?.url) &&
                        "brightness(10)",
                      invert: "1",
                    }}
                    src={ele?.menuItem?.iconUrl}
                    className="img-fluid"
                    alt=""
                  />
                </span>
                <span>{ele?.menuItem?.title}</span>
              </li>
            );
          })}
          <li
            type="button"
            onClick={() => {
              if (isPageEdit) {
                getSnackbarSuccess(
                  "warning",
                  "Please save the details",
                  dispatch
                );
              } else {
                setIsLogoutPopup(true);
              }
            }}
          >
            <span className="icon">
              <img src="./images/logoutIcon.png" className="img-fluid" alt="" />
            </span>
            <span style={{ color: "#DD0000" }}>Logout</span>
          </li>
        </ul>
      </div>
      <Modal
        isOpen={isLogoutPopup}
        className="modal-confirmation-popup"
        overlayClassName="overlay-confirmation-popup"
        ariaHideApp={false}
      >
        <div className="modal-body modal-body-active-popup popup-text">
          Are you sure you want to Logout ?
        </div>
        <div className="modal-footer modal-footer-active-popup">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              localStorage.clear();
              navigate("/");
              setIsLogoutPopup(false);
            }}
            style={{ width: "90px" }}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn btn-primary btn-logout-no"
            onClick={() => setIsLogoutPopup(false)}
          >
            No
          </button>
        </div>
      </Modal>
    </>
  );
};

export default LeftSideBar;
